module.exports = __webpack_public_path__ + "img/post_1.c3720103.jpg";